import ContentCollapsable from './content-collapsable'

export const AmuiContentCollapsable = ContentCollapsable

export default Vue => Vue.component(ContentCollapsable.name, ContentCollapsable)
